// Module
var code = `{{#if showHiddenItemsMessage && hiddenItemsMessage}}
<terceraLabel text="{{hiddenItemsMessage}}" visible="{{.visible}}" />
{{else}}
<div class="js-container-button-stripe" style="{{>visibility}}">
    {{#~/actionArray}}
    {{#~/actionDataDict[this]}}
    {{#if this.visible}}
    <terceraButton terceraButtonStyle="js-button-stripe"
                   text="{{(this.text || '') + (this.instrument ? ' ' + this.instrument : '') + (this.isFiltered ? filteredText : '')}}"
                   enabled="{{this.enabled}}"
                   tooltip="{{this.tooltip}}"
                   on-btnClick="['tradingButtonClick', this.action]" />
    {{/if}}
    {{/}}
    {{/}}
</div>
{{/if}}`;
// Exports
export default code;